import {BaseSearchDTO} from "./baseSearchDTO.interface";

export class CustomerNoteSearchDTO extends BaseSearchDTO {
  filters?: {
    customerId?: string;
    statusId?: number;
  };
}
